<template>
  <div class="Service_banner">
    <div>
      <img src="../../assets/team.jpg" />
    </div>
  </div>
  <div class="contaier Service">
    <div class="inner">
      <div class="content_title">
        <div class="flex title1">
          <div class="flex-item left">
            <span class="line_"></span>
          </div>
          <div class="text">
            <span>服务</span>
            <span class="red">支持</span>
          </div>
          <div class="flex-item right">
            <span class="line_"></span>
          </div>
        </div>
        <div class="title2">SERVICE</div>
      </div>
    </div>
    <div class="service-con">
      <div class="service-desc">
        {{
          this.vision
        }}致力于工业4.0，以智慧制作为奋斗目标，工业自动化技术为先导，加上物联网技术应用，结合大数据，云计算，人工智能等信息技术，为推动工业智能制造，产业智能升级而努力。
      </div>
      <div class="service-content">
        <div class="flex">
          <div class="flex-item direction_item" @click="openInfo()">
            <div class="icon">
              <img src="../../assets/zl.jpg" />
            </div>
            <div>
              <div class="direction_title">资料下载</div>
            </div>
          </div>
          <div class="flex-item direction_item" @click="doRouter()">
            <div class="icon">
              <img src="../../assets/shouh.jpg" />
            </div>
            <div>
              <div class="direction_title">售后服务</div>
            </div>
          </div>
          <div class="flex-item direction_item" @click="doRouter()">
            <div class="icon">
              <img src="../../assets/shenq.jpg" />
            </div>
            <div>
              <div class="direction_title">维修申请</div>
            </div>
          </div>
          <div class="flex-item direction_item" @click="doRouter()">
            <div class="icon">
              <img src="../../assets/jishu.jpg" />
            </div>
            <div>
              <div class="direction_title">技术支持</div>
            </div>
          </div>
          <el-dialog v-model="infoVisible" title="资料下载" width="640px">
            <div cless="mes-list">
              <el-table
                :data="this.infoDate"
                highlight-current-row
                border
                style="width: 100%"
                height="442px"
              >
                <el-table-column
                  prop="originalName"
                  label="相关资料"
                  width="450"
                  align="center"
                >
                  <template v-slot="scope">
                    <div style="cursor: pointer">
                      {{ scope.row.originalName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template #header>
                    <span>操作</span>
                    <el-upload
                      v-if="this.isZ"
                      v-model="this.file"
                      :limit="1"
                      :before-upload="beforeUpload"
                      action="file/path"
                      class="upload-demo"
                    >
                      <el-button>新增</el-button>
                    </el-upload>
                  </template>
                  <template v-slot="scope">
                    <el-button @click="doDown(scope.$index, scope.row)">下载</el-button>
                    <el-button
                      v-if="this.isZ"
                      type="danger"
                      @click="doDelete(scope.$index, scope.row)"
                      >移除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-dialog>
          <el-dialog v-model="usVisible" width="50%" center>
            <div class="mes">
              <div class="us_mes_title">信息通知</div>
              <div class="mes-from">
                <el-form :model="messageFrom" :rules="rules" ref="messageFrom">
                  <el-form-item
                    label="名称："
                    prop="name"
                    label-width="120px"
                    style="height: 50px; font-size: 18px"
                  >
                    <el-input
                      v-model="messageFrom.name"
                      placeholder="您的名字"
                      style="height: 50px; font-size: 18px"
                    />
                  </el-form-item>
                  <el-form-item
                    label="联系电话："
                    prop="contact"
                    label-width="120px"
                    style="height: 50px; font-size: 18px"
                  >
                    <el-input
                      v-model="messageFrom.contact"
                      placeholder="您的电话"
                      style="height: 50px; font-size: 18px"
                    />
                  </el-form-item>
                  <el-form-item
                    label="公司名称："
                    prop="company"
                    label-width="120px"
                    style="height: 50px; font-size: 18px"
                  >
                    <el-input
                      v-model="messageFrom.company"
                      placeholder="您的公司"
                      style="height: 50px; font-size: 18px"
                    />
                  </el-form-item>
                </el-form>
                <div class="mes-footer">
                  <el-button
                    type="primary"
                    @click="submitMessage('messageFrom')"
                    style="height: 50px; width: 84%; font-size: 20px"
                    >提交</el-button
                  >
                </div>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import axios from "axios";
import { useStore } from "vuex";
import SparkMD5 from "spark-md5";
import { v4 as uuid4v } from "uuid";
export default {
  data() {
    return {
      infoVisible: false,
      usVisible: false,
      infoDate: [],
      file: "",
      store: useStore(),
      attachNo: "",
      vision: "",
      isKK: true,
      fileDate: {
        url: "",
        originalName: "",
      },
      messageFrom: {
        name: "",
        contact: "",
        company: "",
        content: "",
      },
      rules: {
        name: [{ required: true, message: "请输入您名称", trigger: "blur" }],
        contact: [
          { required: true, message: "请输入您的联系方式", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的号码", trigger: "blur" },
        ],
        email: [{ type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }],
        company: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        content: [{ required: true, message: "请输入咨询内容", trigger: "blur" }],
      },
    };
  },
  mounted() {
    const user = this.store.state.userInfo;
    this.isZ = user ? (user.permission ? user.permission == 0 : false) : false;
    const host = window.location.host;
    this.isKK = host.includes("fjkkauto");
    this.vision = this.isKK ? "科控科技" : "凯创通达";
  },
  methods: {
    doRouter() {
      this.$router.push("/JobPage");
    },
    openInfo() {
      if (this.isKK) {
        this.infoVisible = true;
        this.queryFileList();
      } else {
        this.$router.push("/JobPage");
      }
    },
    queryFileList() {
      const attachmentDto = {
        subcategory: "down",
        category: "info",
      };
      axios
        .post("/attachment/query", attachmentDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        })
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.infoDate = response.data.data;
            if (!this.attachNo && this.infoDate) {
              this.attachNo = this.infoDate[0].attachNo;
            }
          } else {
            this.infoDate = [];
            if (!this.attachNo) {
              this.attachNo = uuid4v();
            }
          }
        })
        .catch((error) => {
          // 处理请求错误
          console.error("获取资料失败", error);
          if (!this.attachNo) {
            this.attachNo = uuid4v();
          }
        });
    },
    beforeUpload(file) {
      if (!file) {
        this.$message.error("文件丢失取消上传");
        return false;
      } else if (file.size / 1024 / 1024 > 50) {
        this.$message.error("文件不能大雨50M");
        return false;
      }
      try {
        var fileReader = new FileReader();
        //获取文件二进制数据
        fileReader.readAsArrayBuffer(file);
        const spark = new SparkMD5.ArrayBuffer();
        fileReader.onload = async (e) => {
          spark.append(e.target.result);
          this.localUpload(file, spark.end());
        };
      } catch (error) {
        console.error("计算MD5值有误：", error);
        return false;
      }
      return false;
    },
    //上传文件到本地服务器
    localUpload(file, MD5) {
      const fileType = file.name.split(".")[1];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("md5", MD5);
      formData.append("category", "info");
      formData.append("subcategory", "down");
      formData.append("size", file.size);
      formData.append("originalName", file.name);
      formData.append("type", fileType);
      formData.append("method", 0);
      formData.append("attachNo", this.attachNo);
      formData.append("status", 1); // 提交数据到接口
      axios
        .post("/attachment/localUpload", formData, {
          Headers: {
            "Content-Type": "multipart/form-data",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            ElMessage.success("上传成功");
            this.queryFileList();
          } else {
            ElMessage.error("上传失败：" + response.data.message);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("上传失败：", error);
        });
    },
    doDown(index, row) {
      this.usVisible = true;
      this.fileDate.url = row.url;
      this.fileDate.originalName = row.originalName;
    },
    submitMessage(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          // 提交数据到接口
          const messageDto = {
            type: 0,
            name: this.messageFrom.name,
            contact: this.messageFrom.contact,
            company: this.messageFrom.company,
            content: this.fileDate.originalName,
            usCompanyType: this.isKK ? 1 : 2,
          };
          // 提交数据到接口
          axios
            .post("/message/add", messageDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                this.messageChange();
                axios({
                  method: "post",
                  url: "/attachment/downLoad",
                  params: {
                    path: this.fileDate.url,
                    name: this.fileDate.originalName,
                  },
                  responseType: "blob",
                })
                  .then((res) => {
                    const blob = new Blob([res.data], { type: res.data.type });
                    const elink = document.createElement("a");
                    //创建下载链接
                    elink.href = window.URL.createObjectURL(blob);
                    //下载后文件名
                    elink.download = this.fileDate.originalName;
                    document.body.appendChild(elink);
                    //点击下载
                    elink.click();
                    // 下载完成移除元素
                    document.body.removeChild(elink);
                    // 释放掉blob对象
                    window.URL.revokeObjectURL(elink.href);
                    this.fileDate.originalName = "";
                    this.fileDate.url = "";
                    ElMessage.success("下载成功");
                  })
                  .catch((error) => {
                    // 处理请求错误
                    ElMessage.error("请求失败，请检查网络或接口地址");
                    console.error("留言失败", error);
                  });
                this.usVisible = false;
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("留言失败", error);
            });
        } else {
          ElMessage.error("请填写所有必填项");
          return false;
        }
      });
    },
    doDelete(index, row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios
            .get("/attachment/delete", {
              params: {
                id: row.id,
                url: row.url,
                subcategory: "down",
                no: this.attachNo,
                sno: row.sno,
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结
              if (response.data.code === 200) {
                this.queryFileList();
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("文件移除失败", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消移除",
          });
        });
    },
    messageChange() {
      this.messageFrom = {
        name: "",
        contact: "",
        email: "",
        company: "",
        content: "",
        site: "",
      };
    },
  },
};
</script>

<style>
.Service_banner {
  position: relative;
  width: 100%;
  height: 48vh;
  overflow: hidden;
  padding-top: 5px;
}
.Service {
  margin-top: 30px;
}
.Service_banner img {
  width: 100%;
  height: 460px;
}
.service-con {
  text-align: center;
  width: 100%;
  height: 720px;
}
.service-content {
  margin: auto;
  width: 90%;
  margin-top: 10px;
}
.service-desc {
  height: 30px;
  line-height: 30px;
  color: #414141a8;
  font-size: 17px;
  margin-top: 10px;
}
.service-con .icon img {
  width: 100%;
  height: 500px;
}

.service-con .direction_title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  height: 45px;
  line-height: 45px;
}
.service-con .direction_item:hover {
  /* background: #88bffd75; */
  border: 2px solid #88bffd75;
  box-shadow: 0 0 10px 5px rgba(96, 166, 231, 0.712);
}
.service-con .direction_item:hover .direction_title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  height: 50px;
  line-height: 50px;
  background: #1776f17c;
  color: #e9e8e8;
}

.service-con .direction_item {
  background: #f8f8f8;
  border-radius: 3px;
  border: 2px solid #efefef;
  /* cursor: pointer; */
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
  padding: 10px;
  height: 550px;
  margin: 15px;
  cursor: pointer;
}
</style>
